export default "/images/navigation.svg?729ba1adbf47b6533fd6191214769dd2";